module.exports = __webpack_public_path__ + "images/paypal-logo.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/paypal/paypal-logo.jpg
 ** module id = 567
 ** module chunks = 0
 **/